// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24 // 1 day
export const TOKEN_COOKIE = 'funifier.token'
export const REFRESH_TOKEN_COOKIE = 'funifier.refreshToken'
export const BADGES_STORAGE_KEY = 'funifier.badges'
export const VERSION = 'v1.2.2'

/** Catálogo dos cards que o empregado troca pelo prêmio especial. */
export const CARDS_ESPECIAIS_CATALOG_ID = 'cards_especiais'

/**
 * Catálogo do prêmio especial. Fica fora do resgate automático: o empregado
 * guarda o card brilhando na vitrine e escolhe a hora de trocá-lo.
 */
export const PREMIOS_ESPECIAIS_CATALOG_ID = 'premios_especiais'

/** O período de troca do card especial pela recompensa já terminou. */
export const RESGATE_PREMIO_ESPECIAL_ENCERRADO = true

/**
 * Catálogos em que o card já é o prêmio inteiro (1/1): o desafio entrega o card
 * direto e não existe um item de prêmio que o exija.
 */
export const CARDS_AUTOCONTIDOS_CATALOG_IDS = ['cards_gmac_premios']

// Catálogos da temporada 2026
export const CARDS_CATALOG_IDS = [
  '2026_cards_colecionaveis',
  '2026_cards_instantaneos',
  CARDS_ESPECIAIS_CATALOG_ID,
  ...CARDS_AUTOCONTIDOS_CATALOG_IDS,
]
export const PREMIOS_CATALOG_IDS = [
  '2026_premios_colecionaveis',
  '2026_premios_instantaneos',
  PREMIOS_ESPECIAIS_CATALOG_ID,
]

/** Catálogos de card das temporadas anteriores, que ainda aparecem na apuração. */
export const CARDS_CATALOG_IDS_LEGADO = [
  'cards',
  'cards_gemac',
]

/** Todo catálogo cujo item é um card, de qualquer temporada. */
export const TODOS_CARDS_CATALOG_IDS = [
  ...CARDS_CATALOG_IDS,
  ...CARDS_CATALOG_IDS_LEGADO,
]
